import "./blogIndexPage.css";
import SEOTags from "../../utils/SEOTags";
import { BlogCard } from "./BlogCard/BlogCard";
import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Spinner from "../../components/Spinner/Spinner";
import Layout from "../../components/layout/Layout";
import { client } from "../../utils/sanity";
import Pagination from "../AdPage/Pagination/Pagination";

const BlogIndexPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalPosts, setTotalPosts] = useState(0)

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;

  const postPerPage = 21
  const totalPages = Math.max(1, Math.ceil(totalPosts / postPerPage));

  const cache = useRef({
    pages: {},
    total: null
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    const start = (currentPage - 1) * postPerPage;
    const end = start + postPerPage;

    if (cache.current[currentPage]){
      setPosts(cache.current[currentPage]);

      if (cache.current.total !== null){
        setTotalPosts(cache.current.total)
      }

      setLoading(false);
      return;
    }

    setLoading(true)

    client
      .fetch(`
      {
        "posts": *[_type == "post"] 
          | order(publishedAt desc) [$start...$end] {
          _id,
          title,
          "slug": slug.current,
          publishedAt,
          mainImage
        },
      "total": count(*[_type == "post"])
    }
    `,{ start, end },
      )
      .then((data) => {
        setPosts(data.posts);
        setTotalPosts(data.total)
        setLoading(false);

        cache.current[currentPage] = data.posts;

        if (cache.current.total === null) {
          cache.current.total = data.total
        }
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [currentPage]);

  if (loading)
    return (
      <div className="blog-index-spinner-wrapper">
        <Spinner />
      </div>
    );

  if (error) return <p>Ett fel uppstod, vänligen försök igen senare.</p>;

  const sanitizedPosts = posts.map((post) => ({
    id: post._id,
    title: post.title,
    content: "",
    date: post.publishedAt,
    slug: post.slug,
    mainImage: post.mainImage,
  }));

  return (
    <>
      <SEOTags
        title={"Blogg   "}
        description={
          "Upptäck tips och regler för andrahandsuthyrning. Vakansas blogg guidar dig genom avtal, lagar och hur du smidigast hyr ut och hyr en lokal."
        }
        canonicalUrl={
          currentPage === 1 
          ? "/blogg" 
          : `/blogg?page=${currentPage}`
        }
        ogImage={"/images/logo/meta-logo.jpg"}
      />
      <Layout>
        <main
          className="blog-index-container"
          aria-labelledby="blog-title"
          aria-describedby="blog-description"
        >
          <h1 id="blog-title">Blogg</h1>
          <h2 id="blog-description">
            Här kan du läsa Vakansas nya blogginlägg.
          </h2>
          <BlogCard posts={sanitizedPosts} className="blog-index-posts" />
          <Pagination 
            currentPage={currentPage} 
            totalPages={totalPages} 
            onPageChange={(page) => {setSearchParams({page})}}/>
        </main>
      </Layout>
    </>
  );
};

export default BlogIndexPage;
